import { jsxs as i, jsx as c, Fragment as p } from "react/jsx-runtime";
import { a2 as r, a3 as h } from "../../vendor-CPVnY93G.js";
import { forwardRef as l } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as x } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as o } from "../BaseIcon/index.js";
import '../../assets/index16.css';const f = "_checkboxWrapper_pbs5c_1", k = "_checkbox_pbs5c_1", _ = "_indicator_pbs5c_37", e = {
  checkboxWrapper: f,
  checkbox: k,
  indicator: _
}, W = l(
  ({ children: t, labelRef: n, variant: s = "checkbox", ...a }, b) => {
    const d = r(b), m = r(n);
    return /* @__PURE__ */ i(
      h,
      {
        ...x(a),
        ref: m,
        inputRef: d,
        className: e.checkboxWrapper,
        "data-component": "Checkbox",
        children: [
          /* @__PURE__ */ c("div", { className: e.checkbox, "aria-hidden": !0, children: s === "visibility" ? /* @__PURE__ */ i(p, { children: [
            /* @__PURE__ */ c(o, { size: "md", color: "moon", icon: "visibility-checked" }),
            /* @__PURE__ */ c(o, { size: "md", color: "moon", icon: "visibility-unchecked" }),
            /* @__PURE__ */ c(o, { size: "md", color: "moon", icon: "visibility-indeterminate" })
          ] }) : /* @__PURE__ */ c("div", { className: e.indicator }) }),
          t
        ]
      }
    );
  }
);
export {
  W as Checkbox
};
